import clsx from 'clsx';

export default function InputField({
  value,
  onChange,
  onBlur = ()=>{},
  title = '',
  placeholder = '',
  border = true,
  shadow = true,
  errors = null,
  className = '',
}) {
  return (
    <div className={clsx(className)}>
      <label htmlFor="description" className="block text-sm font-medium text-gray-700">
        {title || 'Tytuł'}
      </label>
      <div className="my-1">
        <input
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          value={value}
          name="title"
          id="title"
          placeholder={placeholder || 'Wpisz wartość'}
          className={clsx(
            'block w-full rounded-md p-2 sm:text-sm',
            border
              ? 'border-gray-300 focus:border-teal-500 focus:ring-teal-500'
              : 'border-0 focus:ring-0',
            shadow ? 'shadow-sm' : ''
          )}
        />
        {errors && <p className="mt-1 text-xs font-semibold text-red-500">Zmiana wpływa na URL.</p>}
      </div>
    </div>
  );
}
